import React, { Fragment, useContext, useEffect } from "react";

import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../AbstractElements";

import { Entities } from "../../Shared/Constants";

import TableSearch from "../../Shared/Components/Search/TableSearch";
import DataTableEntitiesComponent from "./DataTableEntitiesComponent";

import EntityContext from "./ContextProvider";
import { PlusCircle } from "react-feather";
import EntityForm from "./EntityForm";
import { hasPermission } from "../../Shared/Utils/userUtils";

const EntitiesList = () => {
  const { modalTogle, setItem, setSearchTerm } = useContext(EntityContext);
  const handleNew = (row) => {
    setItem({});
    modalTogle();
  };
  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);
  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title={Entities} mainTitle={Entities} />
      <Container fluid={true}>
        <Row>
          {/* <ListHeader></ListHeader> */}
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_entity") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nueva entidad
                        </Btn>
                        <EntityForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <DataTableEntitiesComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default EntitiesList;
